import { render, staticRenderFns } from "./organization-cell.vue?vue&type=template&id=4cbdf101&scoped=true"
import script from "./organization-cell.vue?vue&type=script&lang=js"
export * from "./organization-cell.vue?vue&type=script&lang=js"
import style0 from "./organization-cell.vue?vue&type=style&index=0&id=4cbdf101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbdf101",
  null
  
)

export default component.exports